module.exports = __webpack_public_path__ + "static/img/team7.64bf802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team7.png
// module id = NXNO
// module chunks = 1